import { Injectable } from '@angular/core';

import { SeedingCriteriaType } from '@reg/shared/model';

/**
 * Service to get seeding criteria types
 */
@Injectable()
export class SeedingCriteriaTypeService {
    // Consts are a copy of the SeedingCriteriaType enum defined in the floarena-api
    public static get RECORD(): string {
        return 'record';
    }

    public static get YES_NO(): string {
        return 'yes-no';
    }

    public static get NUMERIC(): string {
        return 'numeric';
    }

    private static types: SeedingCriteriaType[] = [
        new SeedingCriteriaType(SeedingCriteriaTypeService.NUMERIC, 'Numeric', true),
        new SeedingCriteriaType(SeedingCriteriaTypeService.YES_NO, 'Yes/No', false),
        new SeedingCriteriaType(SeedingCriteriaTypeService.RECORD, 'Record', false),
    ];

    /**
     * Get all seeding criteria types
     */
    public static getIndex(excludeRecord: boolean = false): SeedingCriteriaType[] {
        if (excludeRecord) {
            return SeedingCriteriaTypeService.types.filter((x: SeedingCriteriaType) => !x.isRecord());
        }

        return SeedingCriteriaTypeService.types;
    }

    /**
     * Get a specific seeding criteria type
     */
    public static get(seedingCriteriaTypeId: string): SeedingCriteriaType {
        const item: SeedingCriteriaType = SeedingCriteriaTypeService.types.filter(
            (x: SeedingCriteriaType) => x.id === seedingCriteriaTypeId,
        )[0];

        if (item) {
            return item.clone();
        }

        return null;
    }
}
